<div class="ir-area ir-mask th-mask" [open]="!isOpen" [attr.data-keyboard]="true" [attr.data-backdrop]="false">
  <form class="ir-modal th-modal" [formGroup]="editForm">
    <div class="ir-modal--title">
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ title }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <h2 class="th-txt"><span innerHtml="{{ message }}"></span></h2>
        <table class="ir-modal-table">
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'inspection.input-lang' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <select name="lang" class="ir-form-set" formControlName="lang" style="text-transform: uppercase">
                  <option *ngFor="let lg of availableLanguages" [value]="lg">{{ lg }}</option>
                </select>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6" *ngIf="closeButton">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="close()">
            <span>{{ cancelButtonText }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6" (click)="submit()">
          <button
            class="ir-btn ir-btn--big ir-btn--block ir-txt--right"
            [ngClass]="danger ? 'th-btn-remove' : 'th-btn-modal--action'"
          >
            <span>{{ okButtonText }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
